import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { REQUISICAO_PUBLICA } from 'src/app/shared/http/requisicao-publica';
import { environment } from 'src/environments/environment';

/** Esta é a parte pública do Portal e App do Aluno; cada serviço do EducaFácil tem a sua. */
export const PRODUTO_PRIVACIDADE = 'aluno';

/** Base da parte pública; a URL da API por cidade é definida antes do bootstrap. */
export function urlPrivacidadePublica(): string {
    return `${environment.api}v2/portal-privacidade/publico`;
}

/** Resposta de `publico/disponibilidade`. */
export interface DisponibilidadePrivacidade {
    disponivel: boolean;
    versao_cookies: number | null;
}

/** Consulta leve, sem token, usada pelo banner de cookies em todas as telas. */
@Injectable({ providedIn: 'root' })
export class PrivacidadePublicaService {
    constructor(private http: HttpClient) {}

    disponibilidade(): Observable<DisponibilidadePrivacidade> {
        return this.http
            .get<{ data: Partial<DisponibilidadePrivacidade> }>(
                `${urlPrivacidadePublica()}/disponibilidade`,
                {
                    context: new HttpContext().set(REQUISICAO_PUBLICA, true),
                    params: new HttpParams().set('produto', PRODUTO_PRIVACIDADE),
                },
            )
            .pipe(
                map(resposta => ({
                    disponivel: resposta.data?.disponivel === true,
                    versao_cookies: resposta.data?.versao_cookies ?? null,
                })),
            );
    }
}
